var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeadlineContainer',{attrs:{"headline":"Competitions","breadcrumbs":[{text: 'Competitions'}]}},[_c('router-link',{staticClass:"btn btn-white",attrs:{"to":"/competitions/create"}},[_c('i',{staticClass:"fa fa-plus"}),_vm._v(" Create\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('CompetitionList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }